import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMoveFloat24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconMoveFloat24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M22.752 13.706a.9.9 0 0 1-.857.941c-1.08.05-1.816-.508-2.293-.853-.521-.377-.785-.54-1.166-.526-.349.013-.58.168-1.046.522-.433.329-1.097.852-2.1.858-1.016.006-1.691-.524-2.13-.855-.475-.358-.712-.515-1.064-.524-.388-.01-.653.15-1.156.508-.467.333-1.176.87-2.22.871-1.049.002-1.763-.537-2.233-.87-.505-.36-.771-.52-1.16-.509-.35.01-.585.166-1.057.524-.438.331-1.11.86-2.124.855a.901.901 0 0 1 .008-1.8c.34.002.567-.141 1.029-.49.427-.324 1.092-.86 2.092-.889 1.059-.03 1.777.5 2.256.841.514.366.787.539 1.186.538.397 0 .668-.173 1.179-.537.476-.34 1.19-.868 2.245-.841 1.005.025 1.673.562 2.103.886.465.35.695.494 1.036.492.338-.002.564-.144 1.02-.49.423-.322 1.08-.853 2.071-.889 1.077-.038 1.81.523 2.284.866.518.374.779.532 1.156.514a.9.9 0 0 1 .941.857m-3.417-3.954a4.6 4.6 0 0 0-.707-.081h-.325a4.6 4.6 0 0 0-.863.113A5.92 5.92 0 0 0 6.458 9.8a4.7 4.7 0 0 0-1.886-.064 7.72 7.72 0 0 1 14.763.016m-.488 5.714a7.717 7.717 0 0 1-13.798-.016q.186-.135.303-.223l.03-.023.058.04c.362.257 1.248.944 2.544 1.145a5.9 5.9 0 0 0 3.967 1.529c1.52 0 2.905-.574 3.953-1.515 1.329-.186 2.212-.908 2.57-1.18l.012-.01.057.04z"
            />
        </svg>
    );
}
export default memo(IconMoveFloat24);
